"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const operators_1 = require("rxjs/operators");
const material_1 = require("@angular/material");
const router_1 = require("@angular/router");
const _4d_mapper_1 = require("4d-mapper");
const app_service_1 = require("../commons/app.service");
const core_1 = require("@ngx-translate/core");
const BaseComponent_1 = require("../commons/BaseComponent");
const application_events_service_1 = require("../xs/services/events/application-events.service");
const loading_spinner_1 = require("../commons/ui/loading-spinner");
class ActivateComponent extends BaseComponent_1.BaseComponent {
    constructor(appService, fourd, service, router, ar, snackBar, dialog, translate, applicationEvents) {
        super(router, snackBar, dialog);
        this.appService = appService;
        this.fourd = fourd;
        this.service = service;
        this.router = router;
        this.ar = ar;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.translate = translate;
        ar.params.subscribe(p => {
            this.token = p.token;
            this.accountUID = p.account;
            this.service.V.api('/access/activate/' + p.token).subscribe(res => {
                this.user = res;
                // Check if user is not active ignore the name attribute as it may contain dummy names to let the user set it
                this.user.name = "";
            }, e => this.error = e);
        });
    }
    activate() {
        this.loading = true;
        this.user.name = this.user['first_name'] + ' ' + this.user['last_name'];
        this.service.V.api('/access/activate/' + this.token, 'post', this.user).subscribe(res => {
            // reset the client id (in case they used a share link prior)
            this.service.V.config.clientId = '4dmapper';
            // If user is active means it is a registered user so redirect to main page to auth or continue to app
            if (this.user.active) {
                this.loading = false;
                var message;
                var action;
                this.translate.get(['SIGNIN.JOIN_SUCCESS', 'GENERIC.OK']).pipe(operators_1.map(params => {
                    message = params['SIGNIN.JOIN_SUCCESS'];
                    action = params['GENERIC.OK'];
                }), operators_1.mergeMap(e => {
                    return this.openDialog(message, null, action);
                })).subscribe(res => {
                    if (res) {
                        // if invite result of account invite and user exists, server will set their last account
                        // to the new invited one, you just need to reload state in case they are already logged in
                        if (this.user.account && this.fourd.activeUser) {
                            this.fourd.teams = null;
                            this.fourd.onReady().subscribe(s => this.router.navigate(['app']));
                        }
                        // if invite not result of account
                        else {
                            this.router.navigate(['app']);
                        }
                    }
                });
            }
            else {
                this.service.V.loginWithUsernameObservable(this.user.username, this.user.password).pipe(operators_1.mergeMap(res => this.appService.refreshMe()), operators_1.mergeMap(res => this.appService.refreshData()))
                    .subscribe(res => {
                    this.router.navigate(['app']);
                }, e => {
                    this.loading = false;
                    loading_spinner_1.LoadingSpinner.end();
                    console.log(e);
                    this.error = e;
                });
            }
        }, e => {
            this.loading = false;
            loading_spinner_1.LoadingSpinner.end();
            this.error = e;
            console.log(this.error);
        });
    }
    ngOnInit() {
        loading_spinner_1.LoadingSpinner.end();
    }
}
exports.ActivateComponent = ActivateComponent;
